class MessageParser {
  constructor(actionProvider, state) {
    this.actionProvider = actionProvider;
    this.state = state;
  }

  parse = (message) => {
    const { messages } = this.state;

    // Add user message to the state
    // The chatbot kit already does this, so we just need to send to the backend

    // Prepare history for the API call
    const history = messages.map(msg => ({
      role: msg.type === 'bot' ? 'model' : 'user',
      parts: [{ text: msg.message }],
    }));

    // Call the backend API
    this.callApi(history, message);
  }

  callApi = async (history, message) => {
    try {
      const response = await fetch('https://yoamobazurto.pythonanywhere.com/chat', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          history: history,
          message: message 
        }),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      this.actionProvider.handleAiResponse(data.response);

    } catch (error) {
      console.error("Error calling chatbot API:", error);
      this.actionProvider.handleAiResponse("Lo siento, parece que estoy teniendo problemas para conectarme. Intenta de nuevo más tarde.");
    }
  }
}

export default MessageParser;
